<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.125 3.125C3.125 2.08947 3.96447 1.25 5 1.25H12.1998C12.7288 1.25 13.2332 1.47346 13.5886 1.86528L16.3888 4.95237C16.7017 5.29732 16.875 5.74637 16.875 6.21208V16.875C16.875 17.9105 16.0355 18.75 15 18.75H5C3.96447 18.75 3.125 17.9105 3.125 16.875V3.125ZM5 2.5C4.65482 2.5 4.375 2.77982 4.375 3.125V13.3588H15.625V6.5H12.4651C12.1199 6.5 11.8401 6.22018 11.8401 5.875V2.5H5ZM13.0901 3.17624V5.25H14.9711L13.0901 3.17624ZM4.375 16.875V14.6088H15.625V16.875C15.625 17.2202 15.3452 17.5 15 17.5H5C4.65482 17.5 4.375 17.2202 4.375 16.875Z" />
</template>
